<template>
  <div class="page-path">
    <el-breadcrumb>
      <el-breadcrumb-item v-for="(item, index) in pathList" :key="index">
        {{ item.meta.label }}
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  name: 'page-path',
  components: {},
  props: {},
  data() {
    return {}
  },
  computed: {
    pathList() {
      const list = []

      this.$route.matched.map(item => {
        if (item.meta.label) {
          list.push(item)
        }
      })

      return list
    },
  },
  watch: {},
  created() {},
  mounted() {},
  beforeDestroy() {},
  methods: {},
}
</script>

<style lang="less" scoped>
.page-path {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  padding: 0 20px;
  height: 40px;
}
</style>
